import React, { useState } from "react";
import { Icons } from "../SkillsAcademy/icons.jsx";
import { useCreateSkillsAcademyEnrollmentRequest } from "../SkillsAcademy/useSkillsAcademy.js";
import { useAuth } from "../../contexts/AuthContext";
import {
  UnlockBackdrop,
  UnlockPanel,
  UnlockCloseBtn,
  UnlockIconRing,
  UnlockTitle,
  UnlockBody,
  UnlockConfirmBtn,
} from "./style.js";

const storageKey = (userId: string, programId: string) =>
  `unlock_requested_${userId}_${programId}`;
const hasRequested = (userId: string, programId: string) =>
  !!localStorage.getItem(storageKey(userId, programId));
const markRequested = (userId: string, programId: string) =>
  localStorage.setItem(storageKey(userId, programId), "1");

interface Props {
  open: boolean;
  onClose: () => void;
  programId?: string;
}

const UnlockModal = ({ open, onClose, programId }: Props) => {
  const { mutate, isPending, isSuccess } = useCreateSkillsAcademyEnrollmentRequest();
  const { loggedInUser } = useAuth();
  const userId = (loggedInUser as { id?: string })?.id ?? "";
  const [alreadyRequested] = useState(() =>
    programId && userId ? hasRequested(userId, programId) : false
  );

  if (!open) return null;

  const showSuccess = isSuccess || alreadyRequested;

  const handleConfirm = () => {
    if (programId) {
      mutate(
        { programId, unlockFull: true },
        { onSuccess: () => markRequested(userId, programId) }
      );
    } else {
      onClose();
    }
  };

  return (
    <UnlockBackdrop onClick={onClose}>
      <UnlockPanel onClick={(e) => e.stopPropagation()}>
        <UnlockCloseBtn type="button" onClick={onClose}>
          <Icons.x size={14} />
        </UnlockCloseBtn>

        <UnlockIconRing>
          <Icons.zap size={28} style={{ color: "#01ECFF" }} />
        </UnlockIconRing>

        {showSuccess ? (
          <>
            <UnlockTitle>Request sent!</UnlockTitle>
            <UnlockBody>
              We'll get back to you as soon as possible to get you enrolled in
              the full program. Keep an eye out in your inbox!
            </UnlockBody>
            <UnlockConfirmBtn type="button" onClick={onClose}>
              Got it
            </UnlockConfirmBtn>
          </>
        ) : (
          <>
            <UnlockTitle>Glad you're enjoying it!</UnlockTitle>
            <UnlockBody>
              Ready to unlock the full program? Click below and we'll reach out
              to get you set up.
            </UnlockBody>
            <UnlockConfirmBtn type="button" onClick={handleConfirm} disabled={isPending}>
              {isPending ? "Sending…" : "Unlock full program"}
            </UnlockConfirmBtn>
          </>
        )}
      </UnlockPanel>
    </UnlockBackdrop>
  );
};

export default UnlockModal;
